module.exports = __webpack_public_path__ + "static/media/interested_program_img.436a2f5d.png";